// extracted by mini-css-extract-plugin
export var formContainer = "_mn-0";
export var message = "_mn-1";